import RouteEnum from "constants/RouteEnum";
import React, { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import "./TopMenuContent.css";

const TopMenuContent: React.FC = () => {
  const { t } = useTranslation();
  const [companyIsActive, setCompanyIsActive] = useState(false);

  useEffect(() => {
    const list = document.querySelector("#companies");
    if (list !== null) {
      const listItems = list.querySelectorAll("li a");
      Array.from(listItems).forEach((item) => {
        if (item.classList.contains("is-active")) {
          setCompanyIsActive(true);
        }
      });
    }
  }, []);

  return (
    <Fragment>
      <li className="header-nav-item">
        <NavLink
          className={({ isActive }) => `menu-link have-sub ${isActive ? "is-active" : ""}`}
          to={RouteEnum.Projects}
        >
          {t("menus.nav-top-menu.projects.title")}
        </NavLink>

        <ul className="sub-menu sub-menu-routes">
          <li>
            <NavLink
              className={({ isActive }) => `menu-link ${isActive ? "is-active" : ""}`}
              to={RouteEnum.Commercials}
            >
              {t("menus.nav-top-menu.projects.commercials")}
            </NavLink>
          </li>
          <li>
            <NavLink className={({ isActive }) => `menu-link ${isActive ? "is-active" : ""}`} to={RouteEnum.Movies}>
              {t("menus.nav-top-menu.projects.movies")}
            </NavLink>
          </li>
          <li>
            <NavLink className={({ isActive }) => `menu-link ${isActive ? "is-active" : ""}`} to={RouteEnum.Series}>
              {t("menus.nav-top-menu.projects.series")}
            </NavLink>
          </li>
        </ul>
      </li>
      <li className="header-nav-item">
        <NavLink className="menu-link" to={RouteEnum.Actors}>
          {t("menus.nav-top-menu.actors.index")}
        </NavLink>
      </li>

      <li className="header-nav-item">
        <p className={`menu-link have-sub companies ${companyIsActive && "is-active"}`}>
          {t("menus.nav-top-menu.companies.index")}
        </p>
        <ul id="companies" className="sub-menu sub-menu-routes">
          <li className="header-nav-item">
            <NavLink
              className={({ isActive }) => `menu-link ${isActive ? "is-active" : ""}`}
              to={RouteEnum.Productions}
            >
              {t("menus.nav-top-menu.companies.productions")}
            </NavLink>
          </li>
          <li className="header-nav-item">
            <NavLink className={({ isActive }) => `menu-link ${isActive ? "is-active" : ""}`} to={RouteEnum.Clients}>
              {t("menus.nav-top-menu.companies.clients")}
            </NavLink>
          </li>
          <li className="header-nav-item">
            <NavLink className={({ isActive }) => `menu-link ${isActive ? "is-active" : ""}`} to={RouteEnum.Casts}>
              {t("menus.nav-top-menu.companies.agencies")}
            </NavLink>
          </li>
        </ul>
      </li>
    </Fragment>
  );
};

export default TopMenuContent;
